import React, { useEffect, useRef, useState } from "react";

import Link from "@material-ui/core/Link";
import { NavLinkText } from "./NavLink.styles";
import PropTypes from "prop-types";
import Tooltip from "@material-ui/core/Tooltip";
import { useLocation } from "react-router-dom";

const NavLink = ({ item, classes, classesText, navigate, isActive }) => {
    const linkRef = useRef(null);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const location = useLocation();
    const active = isActive
        ? isActive(location)
        : location.pathname.startsWith(item.route);

    useEffect(() => {
        const el = linkRef.current;

        if (!el) {
            return;
        }

        const check = () => {
            const typography = el.querySelector(".MuiTypography-root");
            if (typography) {
                setIsOverflowing(
                    typography.scrollWidth > typography.clientWidth
                );
            }
        };

        const observer = new ResizeObserver(check);
        observer.observe(el);

        return () => observer.disconnect();
    }, []);

    return (
        <Tooltip
            title={isOverflowing ? item.name : ""}
            placement="bottom"
            classes={{
                tooltip: classes.tooltip,
                tooltipPlacementBottom: classes.tooltipPlacementBottom,
            }}
        >
            <Link
                ref={linkRef}
                component="a"
                href={item.route}
                className={classes.navItem}
                underline="none"
                onClick={(e) => {
                    if (!e.ctrlKey && !e.metaKey && e.button !== 1) {
                        e.preventDefault();
                        navigate(item.route);
                    }
                }}
            >
                <NavLinkText
                    variant="smallLight"
                    $active={active}
                    className={classesText.borderBottom}
                >
                    {item.name}
                </NavLinkText>
            </Link>
        </Tooltip>
    );
};

NavLink.propTypes = {
    item: PropTypes.object,
    classes: PropTypes.object,
    classesText: PropTypes.object,
    navigate: PropTypes.func,
    isActive: PropTypes.func,
};

export default NavLink;
